import React, {FC} from 'react';
import {WeatherForecastDay, WeatherForecastLocation} from '@/app/interfaces/weather';
import {ForecastDaysMode} from '@/app/constants/forecast';
import {RouteName} from '@/app/constants/routing';
import {useUrlBuilder} from '@/app/routing/useUrlBuilder';
import {WeatherDailyTab} from '../WeatherDailyTab';
import styles from './WeatherDailyTabs.css';

interface WeatherDailyTabsProps {
	location: WeatherForecastLocation;
	daysMode: ForecastDaysMode;
	days: (Pick<WeatherForecastDay, 'date' | 'isHoliday' | 'temperature' | 'condition'> & {isToday: boolean})[];
	selectedDay: number;
}

export const WeatherDailyTabs: FC<WeatherDailyTabsProps> = props => {
	const {location, daysMode, days, selectedDay} = props;
	const urlBuilder = useUrlBuilder();

	return (
		<div className={styles.root}>
			{days.map((day, index) => (
				<WeatherDailyTab
					key={day.date}
					isHoliday={day.isHoliday}
					date={day.date}
					temperature={day.temperature}
					condition={day.condition}
					url={urlBuilder(RouteName.weather, {
						location,
						daysMode,
						dayDate: day.isToday ? undefined : day.date,
					})}
					isSelected={selectedDay === index}
				/>
			))}
		</div>
	);
};

WeatherDailyTabs.displayName = 'WeatherDailyTabs';
